import {reactive} from '@/plugins/compositionApi'

const frame = reactive({
  url: null
})

const getUrl = () => {
  return frame.url
}

const setUrl = url => frame.url = url

export {
  getUrl,
  setUrl
}